<template lang='pug'>
v-form(ref='purchasedCarnetForm' @submit.prevent)
	p.tw-mb-5(class="emd:tw-mb-0") {{$t('form_labels.find_carnet.insert_data', 'Per procedere alla prenotazione inserisci i dati di acquisto del tuo carnet')}}
	div.tw-flex.tw-items-center.tw-gap-2(class="emd:tw-flex-col emd:tw-gap-1" v-if="!isMobile || bookingStore.carnet.fund == null")
		v-text-field(
			id="carnetNumber"
			:label="$t('form_labels.find_carnet.number', 'Numero Carnet')"
			:model-value="carnetNumber"
			:rules="carnetRules"
			class="emd:tw-w-full"
		)
		v-text-field(
			id="name"
			:label="$t('form_labels.find_carnet.name', 'Nome Intestatario')"
			:model-value="name"
			:rules="requiredRules"
			class="emd:tw-w-full"
		)
		v-text-field(
			id="surname"
			:label="$t('form_labels.find_carnet.surname', 'Cognome Intestatario')"
			:model-value="surname"
			:rules="requiredRules"
			class="emd:tw-w-full"
		)
</template>

<script setup>
import {inject, ref} from 'vue';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import { onMounted } from 'vue';
import {useI18n} from "vue-i18n";
import {useBookingStore} from "@/stores/booking";
import {getOnlyNumbers, rules_checkRequiredFields} from "@/common-scripts/utilities";



const stepper = useBookingStepperStore();
const purchasedCarnetForm = ref(null);
const carnetNumber = ref();
const name = ref();
const surname = ref();
const i18n = useI18n();
const carnetRules = [
	v => rules_checkRequiredFields(v, i18n),
	v => {
		carnetNumber.value = getOnlyNumbers(v);
		return true;
	}
];
const requiredRules = [
	v => rules_checkRequiredFields(v, i18n),
];
const isMobile = inject('isMobile');
const bookingStore = useBookingStore();


onMounted(() => {
	if (stepper.step == 'search' && 'carnet' == stepper.bookingType) {
		if(import.meta.env.DEV){
			carnetNumber.value = import.meta.env.VITE_CARNET_BOOKING_CARNETNUMBER;
			name.value = import.meta.env.VITE_CARNET_BOOKING_NAME;
			surname.value = import.meta.env.VITE_CARNET_BOOKING_SURNAME;
		}
	}
});

defineExpose({
	purchasedCarnetForm
});
</script>

<style>

</style>